import {
    logout,
    transactionServices,
    useGetAccountInfo,
    refreshAccount,
    DappUI,
} from '@elrondnetwork/dapp-core'
import { routeNames } from 'routes'
import fridgeImg from '../../luniImages/blankFridge.jpeg'
import './Connect.css'
import Logo from '../Logo'

const LoginComponent = () => {
    const {
        ExtensionLoginButton,
        WebWalletLoginButton,
        LedgerLoginButton,
        WalletConnectLoginButton,
    } = DappUI
    return (
        <div className="connect">
            <Logo />
            <img src={fridgeImg} alt="fridge" className="connect__img" />
            <div className="connect__container">
                <div>
                    <ExtensionLoginButton
                        callbackRoute={routeNames.home}
                        loginButtonText={'Extension'}
                    />
                </div>
                <div>
                    <WebWalletLoginButton
                        callbackRoute={routeNames.home}
                        loginButtonText={'Web wallet'}
                    />
                </div>
                <div>
                    <LedgerLoginButton
                        loginButtonText={'Ledger'}
                        callbackRoute={'asdfasawdawd'}
                    />
                </div>
                <div>
                    <WalletConnectLoginButton
                        callbackRoute={routeNames.home}
                        loginButtonText={'Maiar'}
                    />
                </div>
            </div>
        </div>
    )
}

export default LoginComponent
